import { Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import {Platform} from "ionic-angular";
import {Device} from "@ionic-native/device";
import { AppVersion } from "@ionic-native/app-version";

@Injectable()

export class ActivityLogService {

  private platformString = 'simulator';
  private versionString = null;
  private uuidString = null;

  constructor(
    public platform: Platform,
    public device: Device,
    public appVersion: AppVersion,
    public api: ApiService
  ) {
    if(this.platform.is('android')){
      this.platformString = 'android';
    }
    if(this.platform.is('ios')){
      this.platformString = 'ios';
    }
  }

  /**
   * log
   * @param string log_type
   * @param object content
   */
  public log(log_type, content?){
    if(this.device.uuid){
      this.uuidString = this.device.uuid;
    }
    this.versionString = this.api.app_version;
    if(this.platform.is('cordova')) {
      this.appVersion.getVersionNumber().then((version) => {
        this.versionString = version;
        this.addActivityLog(log_type, content);
      });
    } else {
      this.addActivityLog(log_type, content);
    }
  }

  private addActivityLog(log_type, content){
    this.api.addActivityLog(
      log_type,
      this.platformString,
      this.versionString,
      this.uuidString,
      content
    ).then(() => {
      // do nothing
    }).catch(() => {
      // do nothing
    });
  }

}



// WEBPACK FOOTER //
// ./src/services/activity-log.service.ts